import React from 'react';
import { Link } from 'react-router-dom';

function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-background font-sans">
      <header className="bg-background text-primary p-4">
        <div className="container mx-auto">
          <Link to="/" className="text-3xl font-md text-text">ShareCSV</Link>
        </div>
      </header>
      <main className="flex-grow container mx-auto p-4">
        {children}
      </main>
      <footer className="bg-background text-center p-4 mt-8">
        <p className="text-sm text-secondary">
          Developed with assistance from Claude by Anthropic and DuckDB
        </p>
      </footer>
    </div>
  );
}

export default Layout;